import React from 'react';
import { inject, observer } from 'mobx-react';

import Shortcuts from '@/components/Shortcuts/firstLoad';
import { applyChatbotConfig } from '@/config';
import { FirstInitStore } from '@/stores/firstInit';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { ShortcutsSkeleton } from '@/components/Skeleton';
import { isBatchShowSkeleton } from '@/utils/firstScreenSkeletonControl';

type Props = {
  firstInit: FirstInitStore;
}

const Shortcut = (props: Props) => {
  const { firstInit: { initStore, canShowShortcut, showShortcutsSkeleton }} = props;

  const { shortcutList = [], shouldBottomBarHidden } = initStore;

  const { enable } = applyChatbotConfig('shortcut', props) as {
    enable: boolean;
  };

  if (!enable) {
    return null;
  }

  const realShortcutElement = shortcutList.length ? <Shortcuts /> : null;
  let renderShortcutElement = null;
  if (isBatchShowSkeleton()) {
    if (canShowShortcut) {
      renderShortcutElement = showShortcutsSkeleton ? (
        <ShortcutsSkeleton />
      ) : realShortcutElement;
    }
  } else {
    renderShortcutElement = realShortcutElement;
  }

  // to make sure when Shortcuts shows, it already has shortcutList
  return !shouldBottomBarHidden ? renderShortcutElement : null;
};

export default inject(getChildInject(
  'firstInit',
))(
  observer(Shortcut as React.FC<{}>),
);
